export const catalog = {
  tree: {
    1: {
      images: `./img/catalog/watch/GTS-2-Gold.jpg`,
      text: `Вас ожидает оглушительный успех , а часы <a target="_blank" href="https://bit.ly/3rZon5E">Amazafit GTS 2</a> в стильном корпусе усилят впечатление, которое вы произведете на коллег, друзей или знакомых будь то на вечеринке, на работе или просто на прогулке или спортивной пробежке.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3rZon5E`,
    },
    2: {
      images: `./img/catalog/watch/Bip-U-Pro-Black.jpg`,
      text: `Позаботьтесь о здоровье близких в 2022-м. Сделать это проще, чем кажется, – подарите им умные часы <a target="_blank" href="https://bit.ly/3s4OpEH">Bip U PRO</a>. Они могут измерить уровень сатурации, пульса, стресса, а универсальный черный цвет подойдет и мужчине, и подростку.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/3s4OpEH`,
    },
    3: {
      images: `./img/catalog/watch/Bip-U-Pro-Green.jpg`,
      text: `Год Тигра откроет новые возможности и новые знания, будьте активными и спортивными, а помогут в этом стильные и легкие <a target="_blank" href="https://bit.ly/320IS7c">Bip U Pro Green</a> – умные часы с управлением камерой и плеером смартфона, отслеживанием женского цикла и мощной батареей.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/320IS7c`,
    },
    4: {
      images: `./img/catalog/watch/GTR-2e-Black.jpg`,
      text: `Не усложняйте, призывает Тигр, ведь в легкости больше силы. И этот постулат будто олицетворяют умные часы <a target="_blank" href="https://bit.ly/3IOKEc9">GTR 2e Black</a> – тонкие и легкие, но чутко измеряющие показатели здоровья и физической активности. Порадуйте ими кого-то близкого.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3IOKEc9`,
    },
  },

  snowflake: {
    1: {
      images: `./img/catalog/watch/Bip-U-Black.jpg`,
      text: `Вихрь приятных перемен закружит вас с самого начала года. Не потеряться в нем помогут часы <a target="_blank" href="https://bit.ly/31OSQsA">Bip U</a>, которые измерят и уровень стресса и пульс, если сердце начнет заходиться от счастья.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/31OSQsA`,
    },
    2: {
      images: `./img/catalog/watch/Bip-S-Warm-Pink.jpg`,
      text: `В год Тигра вас ждет много семейных радостей и хлопот. Чтобы не волноваться за малыша, идущего в школу, купите ему недорогие умные часы <a target="_blank" href="https://bit.ly/33jFODy">Bip S Warm Pink</a>. Они будут измерять уровень здоровья ребенка и могут работать без подзарядки до 40 дней.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/33jFODy`,
    },
    3: {
      images: `./img/catalog/watch/GTS-2-mini-Black.jpg`,
      text: `Тигр будет благоволить семье, поэтому особое внимание обратите на подарки родным. Чтобы не ломать голову, выбирайте универсальный вариант – умные и сверхлегкие часы <a target="_blank" href="https://bit.ly/3oSBpzS">GTS 2 Mini Black</a> понравятся любому из близких.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3oSBpzS`,
    },
    4: {
      images: `./img/catalog/watch/Bip-U-Green.jpg`,
      text: `Вас ждет масса новых знакомств, но и старых друзей не забывайте – Тигр ценит преданность. А что лучше покажет заботу о подруге, чем умные часы <a target="_blank" href="https://bit.ly/3dPDarf">Bip U Green</a>, которые считают калории, измеряют уровень стресса и следят за женским циклом.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3dPDarf`,
    },
  },

  ball: {
    1: {
      images: `./img/catalog/watch/GTR-47mm-Titanum.jpg`,
      text: `2022-й готовит для вас карьерный взлет, поэтому заранее обзаведитесь статусным аксессуаром – умные часы <a target="_blank" href="https://bit.ly/3F9OSJv">GTR 47 mm</a> в элегантном титановом корпусе подойдут к деловому костюму, порадуют функционалом и не разрядятся даже в долгой командировке.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3F9OSJv`,
    },
    2: {
      images: `./img/catalog/watch/T-Rex-Pro-Grey.jpg`,
      text: `Год Тигра обещает перемены и благоволит смелым. Вдохновите своего любимого на настоящие мужские поступки настоящим мужским подарком – часами <a target="_blank" href="https://bit.ly/3IK6qhv">T-Rex Pro Grey</a> с прочностью по военным стандартам, которые выдержат любые испытания.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/3IK6qhv`,
    },
    3: {
      images: `./img/catalog/watch/GTR-47mm-Stainless-Steel.jpg`,
      text: `В 2022 году вы переосмыслите значимость семьи и сблизитесь с представителями сильной ее половины. Их мужественность подчеркнут умные часы <a target="_blank" href="https://bit.ly/3dRzpSg">GTR 47 mm Stainless Steel</a> – олицетворение силы и функциональности.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3dRzpSg`,
    },
    4: {
      images: `./img/catalog/watch/GTS-2-Mini-Pink.jpg`,
      text: `2022 год принесет вам прибыль, но только если тратите с умом. Берите на заметку: часы <a target="_blank" href="https://bit.ly/3oSo7mO">GTS 2 Mini Pink</a> выглядят как дорогой бренд, стоят намного дешевле, оснащены 70 видами тренировок. Разве не идеальный подарок подруге?`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3oSo7mO`,
    },
  },

  deer: {
    1: {
      images: `./img/catalog/watch/GTR-2e-Grey.jpg`,
      text: `Тигр ждет от вас движения! Не сидите дома, проведите праздники активно! А часы <a target="_blank" href="https://bit.ly/3EWC6h1">GTR 2e</a> в стильном сером цвете с AMOLED-экраном в этом помогут: в них есть множество тренировок, включая плавание и лыжи.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3EWC6h1`,
    },
    2: {
      images: `./img/catalog/watch/GTS-2e-Purple.jpg`,
      text: `Вы будете покорять окружающих своей харизмой и щедростью. Но чтобы не разориться, выбирайте подарки с умом – например, умные часы <a target="_blank" href="https://bit.ly/3GJygZa">GTS 2e Purple</a> станут достойной альтернативой более именитым аналогам. А этот цвет будет самым модным в 2022-м.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/3GJygZa`,
    },
    3: {
      images: `./img/catalog/watch/Bip-U-Pink.jpg`,
      text: `Тигр символизирует движение, поэтому 2022 год начинайте с занятий спортом всей семьей. Первый шаг к этому – умные часы <a target="_blank" href="https://bit.ly/3GGjJNZ">Bip U Pink</a>, которые посчитают калории, измерят пульс, уровень стресса и отследят женский цикл.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3GGjJNZ`,
    },
    4: {
      images: `./img/catalog/watch/GTS-2e-Purple.jpg`,
      text: `Год Тигра станет для вас временем удачных экспериментов. Смелее, все получится. А начните с сюрпризов для близких – например, с <a target="_blank" href="https://bit.ly/3GJygZa">GTS 2e Purple</a>, которые объединяют полезные функции умных часов с ярким дизайном и приятной ценой.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3GJygZa`,
    },
  },

  snowman: {
    1: {
      images: `./img/catalog/watch/Bip-U-Pro-Pink.jpg`,
      text: `Кажется, кто-то заработался. Выдохните и побалуйте себя подарком. Часы <a target="_blank" href="https://bit.ly/3oPcQDT">Bip U Pro</a> подскажут, когда вы слишком нервничаете, а их трогательный розовый цвет будет ежедневно напоминать, что вы – девочка, не забывайте об этом!`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3oPcQDT`,
    },
    2: {
      images: `./img/catalog/watch/GTR-2-Sport-Edition.jpg`,
      text: `2022 год станет решающим в ваших отношениях. Чтобы укрепить их, сделайте любимому человеку подарок со смыслом – часы <a target="_blank" href="https://bit.ly/3EZIW5x">GTR 2 Sport Edition Obsidian Black</a> – красивый девайс для тех, кто и следит за здоровьем, и хочет выглядеть стильно.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/3EZIW5x`,
    },
    3: {
      images: `./img/catalog/watch/GTS-2-Urban-Grey.jpg`,
      text: `Вы наладите отношения с родными, а может, и расширите семью. Не скупитесь на подарки близким. Впрочем, умные часы <a target="_blank" href="https://bit.ly/3dWcBk1">GTS 2 Urban Grey</a> – отличная альтернатива дорогим аналогам и повод для искренней благодарности от родных.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3dWcBk1`,
    },
    4: {
      images: `./img/catalog/watch/GTS-2e-Black.jpg`,
      text: `В 2022-м вы будете в центре внимания – во многом благодаря вашей заботе о других. Именно такие люди выбирают в подарок умные часы <a target="_blank" href="https://bit.ly/30qu3Kt">GTS 2e Black</a>, измеряющие уровень кислорода и стресса, воспроизводящие музыку и принимающие телефонные вызовы.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/30qu3Kt`,
    },
  },

  boot: {
    1: {
      images: `./img/catalog/watch/T-Rex-Pro-Black.jpg`,
      text: `Больше путешествий – ваш девиз в 2022 году. Поездка на море тоже считается, но если вы за активный отдых, то пригодятся <a target="_blank" href="https://bit.ly/3DNLuCo">T-Rex Pro Black</a> – неубиваемые часы, соответствующие военному стандарту США MIL-STD-810G, для экстремалов и спортсменов.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3DNLuCo`,
    },
    2: {
      images: `./img/catalog/watch/GTS-2-Gold.jpg`,
      text: `Тигр ценит щедрость, но не любит транжирство, поэтому в 2022-м дарите любимым разумную роскошь – умные часы <a target="_blank" href="https://bit.ly/3rZon5E">GTS2 GOLD</a>, которые олицетворяют праздник золотым сиянением, радуют богатым функционалом, но не требуют переплат.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/3rZon5E`,
    },
    3: {
      images: `./img/catalog/watch/T-Rex-Pro-Black.jpg`,
      text: `Смелее врывайтесь в 2022-й! Тигр поддержит любую авантюру, а вы поддержите вкус к приключениям у близких – например, умными часами <a target="_blank" href="https://bit.ly/3dPRv6Z">T-Rex Pro Black</a> с военными стандартами защиты – идеальный подарок для экстремалов и путешественников.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3dPRv6Z`,
    },
    4: {
      images: `./img/catalog/watch/Bip-S-Carbon-Black.jpg`,
      text: `В год Тигра ваша жизнь заиграет новыми красками – совсем как яркий дизайн умных часов <a target="_blank" href="https://bit.ly/3DURpp6">Bip S Carbon Black</a>, которые удивят скептиков работоспособностью до 40 дней, а прагматиков – ценой.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3DURpp6`,
    },
  },

  staff: {
    1: {
      images: `./img/catalog/watch/GTR-2e-Green.jpg`,
      text: `Счастье принесут природные оттенки, Тигр оценит голубой и зеленый. Например, умные часы <a target="_blank" href="https://bit.ly/3E6ARuN">GTR 2e</a> отличаются не только функционалом, но и стилем и изящностью. А модель зеленого цвета станет вашим амулетом на год. `,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3E6ARuN`,
    },
    2: {
      images: `./img/catalog/watch/GTR-2-Mini-Green.jpg`,
      text: `Вас ждет год, полный любви и гармонии. А если рядом с вами настоящая тигрица, подарите ей сверхлегкие и ультрамодные умные часы <a target="_blank" href="https://bit.ly/30ogD1x">GTS 2 mini</a>, которые можно персонализировать, чтобы отразить уникальный характер хозяйки.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/30ogD1x`,
    },
    3: {
      images: `./img/catalog/watch/GTR-2-Classic-Edition-Black.jpg`,
      text: `Год Тигра сулит вашей семье стабильность, но это не повод останавливаться. Продолжайте развитие — и пусть его символом станут умные часы <a target="_blank" href="https://bit.ly/3oRJ9SC">GTR 2 Classic Edition Obsidian Black</a>, под классическим дизайном которых скрыты мощные технологии.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3oRJ9SC`,
    },
    4: {
      images: `./img/catalog/watch/T-Rex-Pro-Blue.jpg`,
      text: `Год Тигра приготовил испытания, но все их вы преодолеете с легкостью. Главное – в компании друзей и неубиваемых умных часов <a target="_blank" href="https://bit.ly/3dPRv6Z">T-Rex Pro Blue</a>, соответствующих военному стандарту США, которые станут надежным подспорьем в ваших приключениях.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3dPRv6Z`,
    },
  },

  bell: {
    1: {
      images: `./img/catalog/watch/GTR-47-Alluminium-alloy.jpg`,
      text: `2022 – год свершений. Настоящему мужчине на этом пути даже не потребуются помощники, разве что умный компаньон – часы <a target="_blank" href="https://bit.ly/3pYQq2v">GTR 47 mm</a> в элегантном алюминиевом корпусе, с широким выбором циферблатов, долгой зарядкой и функцией управления музыкой.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`me`],
      code: ``,
      link: `https://bit.ly/3pYQq2v`,
    },
    2: {
      images: `./img/catalog/watch/GTS-2-Midnight-Black.jpg`,
      text: `Благородный черный – один из любимых цветов Тигра. Подарите любимым цифровой «амулет» – умные часы <a target="_blank" href="https://bit.ly/3pT4uKR">GTS2 Midnight Black</a>, которые принесут удачу в 2022-м, а еще будут измерять показатели здоровья, проигрывать музыку и принимать звонки.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`favorite`],
      code: ``,
      link: `https://bit.ly/3pT4uKR`,
    },
    3: {
      images: `./img/catalog/watch/GTR-47mm-Titanum.jpg`,
      text: `В ваши окна стучится большое счастье, но хватит ли мужества его впустить в дом? Старайтесь подражать силе Тигра, а помогут в этом брутальные часы <a target="_blank" href="https://bit.ly/3F9OSJv">GTR 47 mm Titanum</a>, функционал и внешний вид которых порадуют и в зале, и в офисе.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`family`],
      code: ``,
      link: `https://bit.ly/3F9OSJv`,
    },
    4: {
      images: `./img/catalog/watch/GTS-2e-Green.jpg`,
      text: `Сделайте что-то новое в 2022 году – и это откроет дверь другим позитивным изменениям. Например, начните заниматься спортом вместе с подругой и умными часами <a target="_blank" href="https://bit.ly/3dOBbmS">GTS 2e Green</a> – это современный способ заботы о своем здоровье.`,
      logoImages: `./img/logo/amazfit.png`,
      filter: [`friend`],
      code: ``,
      link: `https://bit.ly/3dOBbmS`,
    },
  },
};
